(function(){
    angular
        .module('appback')
        .directive('ngFancybox', ngfancybox);

        ngfancybox.$inject = ['ResultadosService','$timeout'];
        function ngfancybox(ResultadosService,$timeout){
            return {
	           
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
						element.fancybox({
			                hideOnOverlayClick:false,
			                hideOnContentClick:false,
			                enableEscapeButton:false,
			                showNavArrows:false,
			                onComplete: function(){
			                    $timeout(function(){
			                        $compile($("#fancybox-content"))($scope);
			                        $scope.$apply();
			                        $.fancybox.resize();
			                    })
			                }
			            });
			        });
		        }
          }
      }
})();